import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ClientFormComponent } from "./components/client-form/client-form.component";
import { ClientListComponent } from "./components/client-list/client-list.component";
import { ClientDetailsComponent } from "./components/client-details/client-details.component";

const routes: Routes = [
  { path: '', component: ClientListComponent },
  { path: 'create', component: ClientFormComponent },
  { path: 'edit/:id', component: ClientFormComponent },
  { path: 'details/:id', component: ClientDetailsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule { }
